import React from 'react';
import ThumbnailContainer from './thumbnailcontainer';

export default props => {
  let {
    pageIndexObject,
    currentSelected,
    selectPage,
    thumbnails,
    canvasUrls,
    finishedDrawing,
    updateIndex
  } = props;

  let buttonItems = [];
  if (
    pageIndexObject &&
    pageIndexObject.length > 0 &&
    thumbnails &&
    Object.keys(thumbnails).length > 0
  ) {
    pageIndexObject.map((item, index) => {
      let className = 'thumbnail';
      if (currentSelected === item) {
        className = 'selectedThumb thumbnail';
      }
      let style = null;
      if (!finishedDrawing) {
        style = { display: 'none' };
      }
      buttonItems.push(
        <ThumbnailContainer
          key={item}
          selectPage={selectPage}
          thumbnail={thumbnails[item]}
          classes={className}
          item={item}
          updateIndex={updateIndex}
          canvasUrl={canvasUrls[item]}
          style={style}
          index={index}
        />
      );
      return true;
    });
  }

  return (
    <div
      style={{
        width: '100%',
        minHeight: '100%',
        position: 'absolute',
        backgroundColor: 'gray'
      }}
    >
      <div
        style={{
          paddingTop: '4%'
        }}
      >
        {buttonItems &&
          buttonItems.length > 0 && (
            <div
              style={{
                overflowY: 'auto'
              }}
              className="grid-layout"
            >
              {buttonItems}
            </div>
          )}
        {!finishedDrawing && (
          <img
            src={'/images/spinner.gif'}
            alt="loading"
            style={{ height: '25px', position: 'absolute', top: '50%' }}
          />
        )}
      </div>
    </div>
  );
};
